/* eslint-disable no-throw-literal */
/* eslint-disable no-unused-vars, no-unreachable,  no-console */
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { Symbol } from 'core-js';
import { FORTNIGHT, WEEK, MONTH } from '../constants';

const moment = extendMoment(Moment);

export const resize = () => {
  // console.log('resize');
  // eslint-disable-next-line no-restricted-globals
  const page = parent;
  if (page && page.iframeLoaded && typeof page.iframeLoaded === 'function') {
    page.iframeLoaded();
  }
};

export const getDataForDate = (data, date) => {
  const [year, month, day] = date.toArray();

  if (data[year] === undefined) {
    console.log(year + ' year failed');
    console.log(date);
    console.log(data);
    throw new Error('Undefined year');
    return null;
  }
  if (data[year][month] === undefined) {
    console.log(month + ' month failed');
    console.log(date);
    console.log(data);
    throw new Error('Undefined month');
    return null;
  }
  if (data[year][month][day] === undefined) {
    console.log(day + ' day failed');
    console.log(date);
    console.log(data);
    throw new Error('Undefined day');
    return null;
  }
  return data[year][month][day];
};

export const calculateIntrestFromTo = (
  state,
  amountRemaining,
  startDate,
  endDate,
  processInstallments
) => {
  let index = 0;
  let amountPlusInterest = amountRemaining;
  let compondedInterest = 0;
  const range = moment.range(startDate, endDate);

  if (!moment.isMoment(startDate)) {
    console.log([index, startDate]);
    throw Error('startDate is not a moment object');
  }

  if (!moment.isMoment(endDate)) {
    console.log([index, endDate]);
    throw Error('endDate is not a moment object');
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const date of range.by('day')) {
    // Filter for installment on this date
    const installment = state.installments.filter(
      x => x.date.valueOf() === date.valueOf()
    );

    const d = getDataForDate(state.dayData, date);

    if (d) {
      // Calculate interest
      if (amountPlusInterest > 0) {
        const a = 1 + (d.rate + d.premium);
        const b = 1 / d.daysInYear;
        const c = a ** b - 1;
        const dailyRate = c.toFixed(16);
        const interest = amountPlusInterest * dailyRate; //  * d.premium
        compondedInterest += interest;
        amountPlusInterest += interest;
      }

      if (index === 0) {
        compondedInterest = 0;
        amountPlusInterest = amountRemaining;
      }

      // Subtract installment amount if found
      if (installment.length !== 0 && processInstallments) {
        amountPlusInterest -= installment[0].amount;
      }

      index += 1;
    } else {
      console.error('No data found for day: ' + date.toString());
    }
  }
  return [amountPlusInterest, compondedInterest];
};

export const calculateFinalPayment = state => {
  const { incurredAmount, incurredDate, installments, finalPaymentDate } =
    state;

  let totalLeft = incurredAmount;
  let previousPaymentDate = moment(incurredDate);

  const payments = [];

  let id = 0;

  installments.forEach(item => {
    totalLeft -= item.amount;
    const installmentDate = moment(item.date);
    const [amountPlusInterest, compondedInterest] = calculateIntrestFromTo(
      state,
      totalLeft,
      previousPaymentDate,
      installmentDate,
      false
    );
    totalLeft = amountPlusInterest;

    payments.push({
      id,
      date: item.date,
      type: 'Installment',
      amount: item.amount,
      remaining: totalLeft,
      interest: compondedInterest,
    });
    previousPaymentDate = installmentDate;
    id += 1;
  });

  const finalPaymentMoment = moment(finalPaymentDate);

  const finalPayment = calculateIntrestFromTo(
    state,
    totalLeft,
    previousPaymentDate,
    finalPaymentMoment,
    false
  );
  payments.push({
    id,
    date: finalPaymentDate,
    type: 'Final',
    amount: finalPayment[0],
    remaining: 0,
  });

  return payments;
};

// Calculate the payment schedule
export const calculatePayments = state => {
  const { incurredAmount, incurredDate, installments, finalPaymentDate } =
    state;

  // let { paymentFrequency } = state;
  let totalLeft = incurredAmount;
  let previousPaymentDate = moment(incurredDate);

  const payments = [];

  let id = 1;

  installments.sort((a, b) => a.date - b.date);

  installments.forEach(item => {
    const installmentDate = moment(item.date);
    const [amountPlusInterest, compondedInterest] = calculateIntrestFromTo(
      state,
      totalLeft,
      previousPaymentDate,
      installmentDate,
      false
    );
    totalLeft = amountPlusInterest - item.amount;

    payments.push({
      id,
      date: item.date,
      type: 'Payment',
      amount: item.amount,
      remaining: totalLeft,
      interest: compondedInterest,
    });
    previousPaymentDate = installmentDate;
    id += 1;
  });

  const [amountPlusInterest, compondedInterest] = calculateIntrestFromTo(
    state,
    totalLeft,
    previousPaymentDate,
    new Moment(finalPaymentDate),
    false
  );

  const finalPayment = {
    id: id + 1,
    key: id + 1,
    date: finalPaymentDate,
    amount: '',
    remaining: totalLeft + compondedInterest,
    interest: compondedInterest,
    type: 'Final Payment',
  };
  payments.push(finalPayment);

  return payments;
};

export const calculateDebtForDay = state => {
  let endDate;
  if (state.finalPaymentDate) {
    endDate = moment(state.finalPaymentDate);
  } else {
    endDate = moment();
  }

  const todaysDateString = endDate.format('DD/MM/YYYY');
  const { incurredDate, incurredAmount } = state;

  const totalLeft = incurredAmount;
  const interest = 0;
  const previousPaymentDate = moment(incurredDate);

  const [remainingDebt, finalInterestPeriod] = calculateIntrestFromTo(
    state,
    totalLeft,
    previousPaymentDate,
    endDate,
    true
  );

  return [remainingDebt, interest + finalInterestPeriod, todaysDateString];
};

export const resultString = state => {
  const [amountRemaining, interestRemaining, todaysDateString] =
    calculateDebtForDay(state);
  const result =
    'Your debt as of today is ' +
    amountRemaining +
    '.' +
    'You can pay the remainer of your debt over ' +
    state.payments.length.toString() +
    'payments ' +
    state.frequencyAmount.toString();
};

export const annualDaysOfDate = (date, latestReleaseDate) => {
  // """Returns the amount of days in the year period from Date"""
  if (latestReleaseDate != null) {
    if (date.isAfter(latestReleaseDate)) {
      const start = latestReleaseDate;
      const end = start.clone();
      end.add(12, 'months');
      const previousYear = moment.range(start, end);
      const days = Math.abs(previousYear.diff('days'));
      return days;
    }
  }

  const start = date.clone();
  const end = start.clone();
  end.add(12, 'months');
  const previousYear = moment.range(start, end);
  const days = Math.abs(previousYear.diff('days'));
  return days;
};

export const prepareData = calcData => {
  const { rates, premiums } = { ...calcData };

  // Takes rates and premiums
  let rateRanges = [];
  let premiumRanges = [];

  // Sort the rates by date
  rates.sort(function compare(a, b) {
    const dateA = new Date(a.ReleaseDate);
    const dateB = new Date(b.ReleaseDate);
    return dateA - dateB;
  });

  // Sort the rates by date
  premiums.sort(function compare(a, b) {
    const dateA = new Date(a.LiveDate);
    const dateB = new Date(b.LiveDate);
    return dateA - dateB;
  });

  // For each rate, make the Released Date =  a momentJs date
  rates.forEach((item, index) => {
    // eslint-disable-next-line no-param-reassign
    rates[index].ReleaseDate = moment(item.ReleaseDate, 'YYYY-MM-DD');
  });

  // Generate a rate ranges for 10 years before the first Release Date
  const createEarlyRateRanges = () => {
    // console.log(rates);
    const firstDate = rates[0].ReleaseDate;
    const firstSixMonthlyRate = rates[0].SixMonthlyAverage;
    const tenYearsEarlier = firstDate
      .clone()
      .subtract(10, 'year')
      .add(1, 'day');

    // Generate a range
    const earlyRateRange = moment.range(tenYearsEarlier, firstDate);
    // Generate Iterator
    const months = earlyRateRange.by('months');
    const iterator = months[Symbol.iterator]();

    // Get first date from iterator
    let result = iterator.next();
    const firstDateInRange = result.value;
    let previousDate;
    const ranges = [];
    let i = 0;

    while (!result.done) {
      const date = result.value;
      const rangeStart = date;
      const rangeEnd = date.clone().add(1, 'month');
      if (i === 0) {
        // If not first early range
        previousDate = date;
        i += 1;
        // eslint-disable-next-line no-continue
        continue;
      }
      const newRange = moment.range(rangeStart, rangeEnd);
      newRange.rate = parseFloat(firstSixMonthlyRate);
      newRange.daysInYear = annualDaysOfDate(rangeStart, null);

      newRange.a_s = rangeStart.format('DD-MM-YYYY');
      newRange.b_e = rangeEnd.format('DD-MM-YYYY');

      ranges.push(newRange);
      previousDate = date;
      result = iterator.next();
      i += 1;
    }

    return ranges;
  };

  const createLaterRateRange = () => {
    // // Generate a rate range for the next 11 years
    const lastRate = rates[rates.length - 1];
    const lastDate = lastRate.ReleaseDate;
    const lastSixMonthlyRate = parseFloat(lastRate.SixMonthlyAverage);
    const lastReleaseDate = lastDate;
    const tenYearsLater = lastReleaseDate.clone().add(11, 'year');
    const laterRateRange = moment.range(lastReleaseDate, tenYearsLater);
    const months = laterRateRange.diff('months');
    const ranges = [];
    for (let i = 0; i < months; i += 1) {
      const rangeStart = lastReleaseDate.clone().add(i, 'month').add(1, 'day');
      const rangeEnd = rangeStart.clone().add(1, 'month');
      const newRange = moment.range(rangeStart, rangeEnd);
      newRange.rate = lastSixMonthlyRate;
      newRange.daysInYear = annualDaysOfDate(rangeStart, lastDate);
      ranges.push(newRange);
    }

    return ranges;
  };

  // Generate a rate range for each range provided, except the last
  const createRateRanges = () => {
    const newRateRanges = [];
    rates.forEach((item, index) => {
      if (index === rates.length - 1 || index === 0) {
        // Ignore the first and last
        return;
      }

      const rangeStart = item.ReleaseDate.clone().add(1, 'days');
      const rangeEnd = rates[index + 1].ReleaseDate;
      const range = moment.range(rangeStart, rangeEnd);

      range.rate = parseFloat(item.SixMonthlyAverage);
      range.daysInYear = annualDaysOfDate(rangeStart, null);
      newRateRanges.push(range);
    });

    return newRateRanges;
  };

  rateRanges = [
    ...createEarlyRateRanges(),
    ...createRateRanges(),
    ...createLaterRateRange(),
  ];

  const createEarlyPremiumRanges = () => {
    // Generate a premium ranges for 10 years before the first Release Date
    const firstPremium = premiums[0];
    const firstDate = moment(firstPremium.LiveDate, 'YYYY-MM-DD');
    // console.log(firstDate);
    const premium = parseFloat(firstPremium.Premium);
    const tenYearsEarlier = firstDate
      .clone()
      .subtract(10, 'years')
      .add(1, 'day');

    // Generate a range
    const earlyPremiumRange = moment.range(tenYearsEarlier, firstDate);
    // Generate Iterator
    const months = earlyPremiumRange.by('months');
    const iterator = months[Symbol.iterator]();

    // Get first date from iterator
    let result = iterator.next();
    let previousDate;
    const ranges = [];
    let i = 0;

    while (!result.done) {
      const date = result.value;
      const rangeStart = date;
      const rangeEnd = date.clone().add(1, 'month');
      if (i === 0) {
        // If not first early range
        previousDate = date;
        i += 1;
        // eslint-disable-next-line no-continue
        continue;
      }
      const newRange = moment.range(rangeStart, rangeEnd);
      newRange.premium = premium;
      newRange.daysInYear = annualDaysOfDate(rangeStart, null);

      newRange.a_s = rangeStart.format('DD-MM-YYYY');
      newRange.b_e = rangeEnd.format('DD-MM-YYYY');

      ranges.push(newRange);
      previousDate = date;
      result = iterator.next();
      i += 1;
    }

    return ranges;
  };

  const createLaterPremiumRanges = () => {
    // // Generate a rate range for the next 11 years
    const lastPremium = premiums[premiums.length - 1];
    const lastDate = lastPremium.LiveDate;
    const premium = parseFloat(lastPremium.Premium);
    const lastReleaseDate = moment(lastDate, 'YYYY-MM-DD');
    const tenYearsLater = moment(new Moment(), 'YYYY-MM-DD').add(11, 'years');
    const laterPremiumRange = moment.range(lastReleaseDate, tenYearsLater);
    // Generate Iterator
    const months = laterPremiumRange.by('months');
    const iterator = months[Symbol.iterator]();

    // Get first date from iterator
    let result = iterator.next();
    let previousDate;
    const ranges = [];
    let i = 0;

    while (!result.done) {
      const date = result.value;
      const rangeStart = date.clone().add(1, 'day');
      const rangeEnd = date.clone().add(1, 'month').add(1, 'day');
      if (i === 0) {
        // If not first early range
        previousDate = date;
        i += 1;
        // eslint-disable-next-line no-continue
        continue;
      }
      const newRange = moment.range(rangeStart, rangeEnd);

      newRange.premium = premium;
      newRange.daysInYear = annualDaysOfDate(rangeStart, null);

      previousDate = result.value;
      result = iterator.next();
      if (!result.done) {
        ranges.push(newRange);
      }
      i += 1;
    }

    return ranges;
  };

  const createPremiumRanges = () => {
    // Generate a premium range for each range provided, except the last
    const newPremiumRanges = [];
    premiums.forEach((item, index) => {
      if (index === premiums.length - 1) {
        // Ignore the last rate
        return;
      }
      const rangeStart = moment(item.LiveDate, 'YYYY-MM-DD').add(1, 'days');
      const rangeEnd = moment(premiums[index + 1].LiveDate, 'YYYY-MM-DD');
      const range = moment.range(rangeStart, rangeEnd);

      range.premium = parseFloat(item.Premium);
      range.daysInYear = annualDaysOfDate(rangeStart, null);
      newPremiumRanges.push(range);
    });
    return newPremiumRanges;
  };

  const generateDayData = () => {
    const data = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const range of premiumRanges) {
      const dateRange = moment.range(range.start, range.end);
      // eslint-disable-next-line no-restricted-syntax
      for (const date of dateRange.by('day')) {
        const [year, month, day] = date.toArray();

        if (data[year] === undefined) {
          data[year] = [];
        }
        if (data[year][month] === undefined) {
          data[year][month] = [];
        }
        if (data[year][month][day] === undefined) {
          data[year][month][day] = {
            premium: range.premium,
            daysInYear: range.daysInYear,
            rate: undefined,
          };
        }
      }
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const range of rateRanges) {
      const dateRange = moment.range(range.start, range.end);
      // eslint-disable-next-line no-restricted-syntax
      for (const date of dateRange.by('day')) {
        const [year, month, day] = date.toArray();

        if (data[year] === undefined) {
          data[year] = [];
        }
        if (data[year][month] === undefined) {
          data[year][month] = [];
        }
        if (data[year][month][day] === undefined) {
          data[year][month][day] = {
            premium: range.premium,
            daysInYear: range.daysInYear,
            rate: undefined,
          };
        } else {
          data[year][month][day].rate = range.rate;
          data[year][month][day].daysInYear = range.daysInYear;
        }
      }
    }
    return data;
  };

  premiumRanges = [
    ...createEarlyPremiumRanges(),
    ...createPremiumRanges(),
    ...createLaterPremiumRanges(),
  ];

  // console.log(rateRanges);

  const dayData = generateDayData();
  return dayData;
};
